import config from "../common/Config";
import useAuth from "../hooks/useAuth"
import { useLocation, useNavigate } from "react-router-dom"
import refreshToken from "./refreshToken"

const useFetch = () => {
	const { auth, setAuth } = useAuth();
	const navigate = useNavigate()
	const location = useLocation()

	const privateFetch = async (url, options) => {
		options = {
			...options,
			headers: { ...(options?.headers ?? {}), authorization: 'Bearer ' + auth.accessToken }
		}

		// Tenta fazer acesso com o token
		const tryAccessToken = await fetch(url, options)
		.catch(e => new Object().status = 500)

		// Se estiver valido, retorna a chamada
		if (tryAccessToken.status == 200) {
			return tryAccessToken
		}
		// Se barrou no throttling, redireciona para pagina de erro
		else if (tryAccessToken.status == 429) {
			navigate('/error/tooManyRequests')
			return { 
				status		: 429,
				message 	: "Muitas Conexões! Tente novamente mais tarde."
			}			
		}
		// Senao, busca um novo token
		else {
			const refresh = await refreshToken()

			if (refresh.success) {
				const data = refresh.data

				setAuth({
					userId		: data.userId,
					user		: data.user,
					accessToken	: data.accessToken
				})

				options = {
					...options,
					headers: { ...(options?.headers ?? {}), authorization: 'Bearer ' + data.accessToken }
				}

				return await fetch(url, options)
				.then(async result => {
					if (result.status === 429) navigate('/error/tooManyRequests')
					return result
				})
				.catch(() => {
					return { json: () => ({ message: 'Falha na autenticação! Efetuar novo login!' }) }
				})
			}
			else if (refresh.status == 429) {
				navigate('/error/tooManyRequests')
				return { status: 429, message: 'Muitas Conexões! Tente novamente mais tarde.' }
			}
			else {
				window.location.reload();
				await new Promise(r => setTimeout(r, 2000));
				return { json: () => ({ message: 'Falha na autenticação! Efetuar novo login!' }) }
			}
		}
	}

	return privateFetch
}

export default useFetch